import api from '../../../api/index';
import apiApp from '../../../api/shopkeeperAppApi';
import apiAppOld from '../../../api/shopkeeperAppApiOld';

export default {
  uploadFileApiApp({}, file) {
    return apiAppOld.post('/upload-file', file);
  },
  uploadFileApiAppCategoria({}, file) {
    return apiApp.post('/upload-file-app', file);
  },
  uploadFileApiAppPremio({}, file) {
    return apiApp.post('/upload-file-premio', file);
  },
  uploadFileNewProduct({}, file) {
    return apiApp.post('/upload-file-new-product-app', file);
  },
  uploadPdfFileProduct({}, file) {
    return apiApp.post('/upload-pdf-file-product', file);
  },
  deleteVideoProduct({}, data) {
    return apiApp.delete(`/delete-video-product/${data}`);
  },
  deletePdfFileProduct({}, data) {
    return apiApp.delete(`/delete-pdf-product/${data}`);
  },
  uploadVideoNewProduct({}, url) {
    return apiApp.post('/video-new-product-app', url);
  },
  getVideoProduct({}, data) {
    console.log('Rota:', data);
    return apiApp.get(
      `/get-video-product-app/${data.productId}/${data.shopId}`
    );
  },
  uploadFileNewCategory({}, file) {
    return apiApp.post('/upload-file-new-category-app', file);
  },
  uploadFileBannerHome({}, file) {
    return apiApp.post('/upload-file-banner-home', file);
  },
  uploadFileApp({ rootGetters }, file) {
    return api.post('/upload-file-app', file, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  uploadFiles({ rootGetters }, files) {
    return api.post('/upload-files', files, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  deleteImageProduct({ rootGetters }, data) {
    return apiApp.post('/delete-image-product', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  sendUploadFiles({ rootGetters }, files) {
    return api.post('/upload-file', files, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  deleteFile({ rootGetters }, filename) {
    return api.delete(`/delete-file/${filename}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  uploadResume({ rootGetters }, file) {
    return api.post('/upload-resume', file, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  uploadSpreadsheetsToExport({ rootGetters }, files) {
    return api.post('/upload/spreadsheets-to-export', files, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
        // 'Content-Type': 'multipart/form-data',
        'Content-Disposition': 'attachment',
        'Content-Type': 'application/octet-stream',
      },
    });
  },
  getFileBase64({ rootGetters }, { url }) {
    return api.get(`get-file-base64?url=${url}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
};
